import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TransactionsPage } from '@/features/billing/transactions-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Transactions du locataire (lot L01) : chaque paiement d'une facture. */
export const Route = createFileRoute('/$tenant/billing/transactions/')({ component: TransactionsRoute });

function TransactionsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="transactions"
      crumbs={[{ label: t('nav.items.transactions') }]}
    >
      <TransactionsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
